export const PROVISION_PRIORITY_CLAIM_ID = 4;
export const VICTIM_PROFESSION_PRIORITY_CLAIM_ID = 5;
export const CLAIM_NATURE = {
  HYBRID: 3,
  TRANSACTION: 1,
  JUDICIARY: 2,
};
export const VICTIM_QUALITY_PASSENGER_ID = '2';

export const GLOBAL_STATUS = {
  VALIDATED: 'VALIDATED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  CONTESTED: 'CONTESTED',
  MODIFIED: 'MODIFIED',
};

export const OPENING_TYPE = {
  USAGE: 'USAGE',
  NORMAL: 'NORMAL',
};

export const OPENING_STATE = {
  COMPLETED: 'COMPLETED',
  NOT_COMPLETED: 'NOT_COMPLETED',
};
